import type { DayButtonProps } from "react-day-picker";

export const DayButton = ({
  day,
  modifiers,
  className,
  ...rest
}: DayButtonProps) => (
  <button type="button" className={className} {...rest}>
    {day.date.getDate()}
    {modifiers.today && !modifiers.selected && (
      <span className="absolute bottom-[3px] left-1/2 h-[4px] w-[4px] -translate-x-1/2 rounded-full bg-black" />
    )}
  </button>
);
